import { useEffect, useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";

function PublicControl() {
  const params = useParams();
  const { shortcut='' } = params;
  // get refreshInterval on the url query
  const location = useLocation();

  const searchParams = useMemo(() => {
    return new URLSearchParams(location.search);
  }, [location]);
  
  let refreshInterval = useMemo(() => {
    let res = parseInt(searchParams.get('r'));
    if (isNaN(res)) {
      res = 45*60*1000;
    }
    return res;
  }, [searchParams]);

  // const [loaded, setLoaded] = useState(false);

  const source = (`${process.env.REACT_APP_API_ENDPOINT}/p/${shortcut}`);

  useEffect(() => {
    const intId = setInterval(() => {
      // print the response to the console
      fetch(source+"?nocache=1", {
        method: 'GET',
      })
      // .then(response => response.text())
      // .then(data => {
      //   console.log(data);
      // });
    }, refreshInterval);
    // console.log('Refresh interval: ', refreshInterval);

    return () => {
      clearInterval(intId);
    }
  }, [source, refreshInterval]);

  return (
  <div
    style={{
      height: '100vh',
      width: '100vw',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <iframe
      style={{
        height: '100%',
        width: '100%',
        border: 'none',
        // ...(!loaded ? {display: 'none'} : {})
      }}
      src={source}
      title="Control"
      // onLoad={() => {setLoaded(true);}}
      allowFullScreen
    >
    </iframe>
    {/* <CircularProgress sx={{...(loaded ? {display: 'none'} : {})}}/> */}
  </div>
  );
}

export default PublicControl;